import React from 'react';

export default function Logo({ className = '' }) {
  const viewBox = "0 0 115 32";

  return (
    <svg 
      className={className} 
      viewBox={viewBox} 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'block', width: 'auto' }}
    >
      <defs>
        <linearGradient id="logoGradCore" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#9b7bff" />
          <stop offset="100%" stopColor="#e3b073" />
        </linearGradient>
        <filter id="logoGlow" x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>

      {/* "adap" text */}
      <text 
        x="0" 
        y="24" 
        fontFamily="'Space Grotesk', system-ui, sans-serif" 
        fontSize="28" 
        fontWeight="700" 
        fill="#f3f1f7" 
        letterSpacing="-0.5"
      >
        adap
      </text>

      {/* Infinity Symbol (serving as the "8") */}
      <g transform="translate(68, 0)">
        <path
          d="M 16 17 C 8 5, -2 11, -2 17 C -2 23, 8 29, 16 17 C 24 5, 34 11, 34 17 C 34 23, 24 29, 16 17 Z"
          stroke="url(#logoGradCore)"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          filter="url(#logoGlow)"
        />
      </g>
    </svg>
  );
}
